import sys from '@truckdown/jsclient';
import * as icons from '@truckdown/jsclient/icons';
import * as apis from '@truckdown/jsclient/apis';
import * as locations from '@truckdown/locations';
import { defineComponent, ref, computed, reactive } from 'vue';
import { email, required, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { UpdateInfoModel } from '../Services/UpdateInfoModel';
import { ILegacyListingService } from '../Services/ILegacyListingService';

const phoneRegex = /^1?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

const isValidPhoneNumber = function (number: string) {
    if (!number || number.length == 0) {
        return true;
    }
    const match = number.match(phoneRegex);
    if ((match?.length ?? 0) > 0) {
        return true;
    }
    return false;
}

const getValidationRules = function () {
    if (sys.framework.context.isAuthenticated()) {
        return {
            comment: {
                required
            }
        };
    }

    return {
        name: {
            required
        },
        email: {
            required,
            email
        },
        phone: {
            required,
            isValidPhoneNumber: helpers.withMessage('Value is not a valid phone number', isValidPhoneNumber)
        },
        comment: {
            required
        }
    };
};

const getInitialState = function () {
    if (sys.framework.context.isAuthenticated()) {
        return {
            name: sys.framework.context.user?.firstName + ' ' + sys.framework.context.user?.lastName,
            phone: sys.framework.context.user?.phone ?? '',
            email: sys.framework.context.user?.email ?? '',
            comment: ''
        };
    }

    return {
        name: '',
        email: '',
        phone: '',
        comment: ''
    };
}

export default defineComponent({
    props: {
        listing: {
            type: Object as () => locations.Listing,
            required: true
        }
    },
    setup: function (props, ctx) {
        var listing = props.listing as locations.Listing;

        const message = ref<string>('');

        const isAuthenticated = computed(() => {
            return sys.framework.context.isAuthenticated();
        });

        const state = reactive(getInitialState());

        const validationRules = getValidationRules();

        const v$ = useVuelidate(validationRules, state)

        const submit = async function (ev: Event) {
            const isFormCorrect = await v$.value.$validate();

            if (isFormCorrect) {
                var service = sys.framework.getRequiredService<ILegacyListingService>('ILegacyListingService');
                var model = new UpdateInfoModel(
                    listing.id,
                    state.name,
                    state.email,
                    state.phone,
                    state.comment
                );

                var res = await service.updateInfo(model);
                if (res) {
                    message.value = 'Your information has been sent.  We will review the information and apply the updates within the next business day.';
                } else {
                    message.value = 'There was an error sending the report.  We are looking into the issue.  In the meantime, please feel free to send a note through our general <a href="/contact">Contact Us</a> page.';
                }

            }
        }

        const closeForm = function (ev: Event) {
            sys.events.emit('close-listing-form', props.listing.id);
        }

        const moreInfoUrl = computed(() => {
            if (sys.framework.context.sys == 'planrv') {
                return '/shop/features';
            }
            return '/shop/fleets';
        });

        return {
            isAuthenticated,
            message,
            state,
            v$,
            submit,
            closeForm,
            moreInfoUrl
        }
    }
});
